import { IPermissionScreen } from "../common/data/dtos/permission-screen";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/PermissionScreen';

interface PermissionScreenResponse {
    success: boolean;
    permissionScreen?: IPermissionScreen;
    permissionScreens?: IPermissionScreen[];
    error?: string;
}

type CreatePermissionScreenType = Omit<IPermissionScreen, 'id'> | Partial<IPermissionScreen>;

const createPermissionScreens = async (permissionScreens: CreatePermissionScreenType[]): Promise<PermissionScreenResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IPermissionScreen>(`${BASE_PATH}`, permissionScreens);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deletePermissionScreen = async (id: string): Promise<PermissionScreenResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IPermissionScreen>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getPermissionScreensByPermission = async (id: string): Promise<PermissionScreenResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IPermissionScreen>(`${BASE_PATH}/GetByPermission?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, permissionScreens: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createPermissionScreens,
    deletePermissionScreen,
    getPermissionScreensByPermission
};